import React from 'react'

export default function Throwing({ className }) {
  return (
    <svg
      className={`${className} w-8 h-8 text-[#F82117]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height="30"
      viewBox="0 0 24 24"
      width="24"
    >
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fontSize="16"
        fontFamily="Arial, sans-serif"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        T
      </text>
    </svg>
  );
}
